import * as React from "react";
const SvgFiRrSkeleton = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19.812 18.169c-.543-1.326-1.771-2.157-3.213-2.169H13v-2h3a1 1 0 1 0 0-2h-3v-2h4a1 1 0 1 0 0-2h-4V6h5a1 1 0 1 0 0-2h-5V2h6a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2h6v2H6a1 1 0 1 0 0 2h5v2H7a1 1 0 1 0 0 2h4v2H8a1 1 0 1 0 0 2h3v2H7.393a3.44 3.44 0 0 0-3.205 2.169 3.44 3.44 0 0 0 .763 3.795l.572.571A4.97 4.97 0 0 0 9.058 24h5.885a4.97 4.97 0 0 0 3.535-1.465l.572-.571a3.44 3.44 0 0 0 .762-3.795m-2.177 2.381-.572.571a2.98 2.98 0 0 1-2.121.879H9.057a2.98 2.98 0 0 1-2.121-.879l-.572-.571a1.45 1.45 0 0 1-.326-1.623A1.45 1.45 0 0 1 7.4 18c.827 0 1.599.673 1.599 1.5v.5a1 1 0 1 0 2 0v-.5a3.5 3.5 0 0 0-.338-1.5h2.677A3.5 3.5 0 0 0 13 19.5v.5a1 1 0 1 0 2 0v-.5c0-.827.764-1.5 1.591-1.5a1.45 1.45 0 0 1 1.37.927 1.45 1.45 0 0 1-.326 1.623"
    />
  </svg>
);
export default SvgFiRrSkeleton;
